import {
  AddCustomerMutation,
  AddCustomerMutationVariables,
} from '@api/generated/graphql';
import { gql, useMutation } from '@apollo/client';
import { retryMutation } from '@api/lib/retryMutate';
import { ADD_CUSTOMER_MUTATION_OPERATION_NAME } from 'src/constants/operations';

export const ADD_CUSTOMER_MUTATION = gql`
  mutation AddCustomer($input: CustomerAddInput!, $tenantId: ID!) {
    addCustomer(input: $input, tenantId: $tenantId) {
      id
      name
      type
      locations {
        id
      }
    }
  }
`;

export function useAddCustomerMutation() {
  const [mutate, { called, data, error, loading, reset }] = useMutation<
    AddCustomerMutation,
    AddCustomerMutationVariables
  >(ADD_CUSTOMER_MUTATION);

  const addCustomer = async (variables: AddCustomerMutationVariables) => {
    return await retryMutation(
      () =>
        mutate({
          variables,
        }),
      {
        operationName: ADD_CUSTOMER_MUTATION_OPERATION_NAME,
      },
    );
  };

  return {
    addCustomer,
    called,
    data,
    error,
    loading,
    // I think these are the conditions for success and maybe throw in !!data
    success: called && !error && !loading,
    reset,
  };
}
